import commonsApi from '@/api/commons'
export default {
  data () {
    return {
      initialFormValues: {},
      isLoading: this.isOnEditMode
    }
  },
  props: {
    isOnEditMode: {
      type: Boolean,
      required: true,
      default: false
    }
  },
  methods: {
    loadForm (form = this.form, getItemDetailObj) {
      this.initialFormValues = JSON.stringify(this.form)
      return commonsApi.getItemDetail({
        path: getItemDetailObj.path,
        id: getItemDetailObj.id
      })
        .then(response => {
          this.form = response
          this.isLoading = false
        })
        .catch(error => {
          throw error
        })
    }
  }
}
